import { cn } from '@/lib/utils';
import { LoaderCircle } from 'lucide-react';

const Spinner = ({ className }: { className?: string }) => {
  return (
    <LoaderCircle
      className={cn('text-muted-foreground h-16 w-16 animate-spin', className)}
    />
  );
};

Spinner.displayName = 'Spinner';

export { Spinner };
